


















































// vendor
import { defineComponent, computed, ref, PropType } from "@vue/composition-api";
// project
import { generateGUID } from "@/utils/guid";
import { ContextMenu, ContextOption, IContextMenu} from "@/components.generic/context-menu";
import * as AppModal from "@/AppModal";

export type ListItem = {
	icon:string;
	name:string;
	iconColor?:string;
	fn:() => void;
	contextFn:() => ContextOption[];
	activeFn?:() => boolean;
	routeFn?:() => any;
};

export default defineComponent({

	props:{
		options:{
			type:Array as PropType<ListItem[]>,
			default:() => []
		}
	},
	// components:{
	// 	ContextMenu
	// },
	setup(props){
		
		// const contextMenu = ref<IContextMenu>();


		const loopKeys = computed(() => props.options.map(o => generateGUID()));

		const openContext = (e:any, index:number) => {
			const option = props.options[index];
			AppModal.context(e, option.contextFn());
		};
		
		const clickOption = (index:number) => {

		};

		const getIconColor = (index:number) => {
			const option = props.options[index];
			return option.iconColor ? option.iconColor : "white";
		};

		const getItemRoute = (index:number) => {
			const fn = props.options[index].routeFn;
			return fn ? fn() : null;
		};

		const isActive = (index:number) => {
			const fn = props.options[index].activeFn;
			return fn ? fn() : false;
		};

		return {
			openContext,
			// contextMenu,
			generateGUID,
			loopKeys,
			isActive,
			getItemRoute,
			getIconColor,
		};
	}
});

